import { EpgViewConfig } from '../src/types';

export const defaultEpgViewConfig: EpgViewConfig = {
    pixelsPerMin: 10,
    currentTimeUpdateInterval: 60,
    visibleChunkSizeViewports: 2,
};
